module.exports = __webpack_public_path__ + "img/EN_IG.2a70d416.jpg";